import React, { useContext, useEffect } from "react";
import ConfigContext from "../context/ConfigContext";
import { useApiRequest } from "./useApiRequest";
import PayPeriodContract from "../contracts/PayPeriodContract";
import loader from "../content/images/icon_loading.gif";

export const PayCyclesCombo = ({ data, setPayPeriod }) => {
	const payPeriodChanged = (event) => {
		const idx = event.target.selectedIndex;
		setPayPeriod(new PayPeriodContract(event.target.value, event.target.options[idx].dataset.pending === "true"));
	};

	useEffect(() => {
		// Manually set the first (pending) payCycle
		const pendingPayPeriod = data.find((item) => item.isPending) !== undefined ? data.find((item) => item.isPending) : data[0];
		setPayPeriod(new PayPeriodContract(`${pendingPayPeriod.year}-${pendingPayPeriod.month}-${pendingPayPeriod.day}`, pendingPayPeriod.isPending));
	}, [data]);

	return (
		<div>
			<label>Pay Cycles</label><br></br>
			<select onChange={payPeriodChanged}>
				{data.map((payCycle, key) => <option key={key} value={`${payCycle.year}-${payCycle.month}-${payCycle.day}`} data-pending={payCycle.isPending}>{`${payCycle.month}/${payCycle.day}/${payCycle.year}${payCycle.isPending ? " (Pending)" : ""}`}</option>)}
			</select >
		</div>
	);
};

export const PayCycles = ({ setPayPeriod, clientNumber }) => {
	const configData = useContext(ConfigContext);
	const { data, error, isLoaded } = useApiRequest(configData.REACT_APP_PAY_PERIOD_URL + `/${clientNumber}`);

	if (error !== null) {
		console.log("error fetching pay cycles: ", error.message);
		return <div>Error: Unable to retrieve Pay Cycles</div>;
	}
	if (!isLoaded) {
		return <img src={loader} alt="Loading " />;
	}
	if (isLoaded) {
		return (
			data.length > 0 ? <PayCyclesCombo data={data} setPayPeriod={setPayPeriod} /> : <div></div>
		);
	}
};